
const procurementChartMixin = {
  computed: {
    year_data() {
      return this.projects_stats && this.projects_stats.tenders_last_ten_years ? this.projects_stats.tenders_last_ten_years.tenders_per_year.buckets.map(b => ({
        year: b.key_as_string,
        contracts: b.doc_count,
        amount: b.tax_exclusive_amount.value,
      })) : [];
    },
    cpv_data() {
      return this.projects_stats && this.projects_stats.cpvs ? this.projects_stats.cpvs.buckets.map(b => ({
        key: this.splitIntoSegments(b.key, 3),
        contracts: b.doc_count,
        amount: b.tax_exclusive_amount.value,
      })) : [];
    },
    contract_type_data() {
      return this.projects_stats && this.projects_stats.contract_types ? this.projects_stats.contract_types.buckets.map(b => ({
        key: b.key,
        contracts: b.doc_count,
        amount: b.tax_exclusive_amount.value,
      })) : [];
    },
    tenders_per_location() {
      return this.projects_stats && this.projects_stats.tenders_per_location ? this.projects_stats.tenders_per_location.buckets.map(b => ({
        key: b.key,
        contracts: b.doc_count,
        amount: b.tax_exclusive_amount.value,
      })) : [];
    },
    top_awarded_parties() {
      return this.projects_stats && this.projects_stats.top_awarded_parties && this.projects_stats.top_awarded_parties.awarded_parties ? this.projects_stats.top_awarded_parties.awarded_parties.buckets.map(b => ({
        key: b.key,
        contracts: b.doc_count,
        amount: b.tax_exclusive_amount.value,
        tenderAmount: b.tender_result_tax_exclusive_amount.value,
        bajaPct: {
          total_contracts: b.less_than_bidding.doc_count,
          pct_contracts: b.less_than_bidding.doc_count / b.doc_count * 100,
          avg: b.less_than_bidding.less_than_bidding_avg.value,
        },
      })) : [];
    },
    top_contracting_parties() {
      return this.projects_stats && this.projects_stats.tenders_per_contracting_party ? this.projects_stats.tenders_per_contracting_party.buckets.map(b => ({
        key: b.key,
        contracts: b.doc_count,
        amount: b.tender_results.tax_exclusive_amount.value,
        tenderAmount: b.tender_results.tender_result_tax_exclusive_amount.value,
        bajaPct: {
          total_contracts: b.tender_results.less_than_bidding.doc_count,
          pct_contracts: b.tender_results.less_than_bidding.doc_count / b.doc_count * 100,
          avg: b.tender_results.less_than_bidding.less_than_bidding_avg.value,
        },
      })) : [];
    },

    data_available() {
      return (
        (this.year_data.length > 0)
        || (this.cpv_data.length > 0)
        || (this.contract_type_data.length > 0)
        || (this.tenders_per_location.length > 0)
        || (this.top_awarded_parties.length > 0)
        || (this.top_contracting_parties.length > 0)
      );
    },
  },
  methods: {
    splitIntoSegments(str, n, minChunkSize = 10) {
      const segments = [];

      let startIndex = 0;

      for (let i = 0; i < n; i += 1) {
        const spaceIndex = str.indexOf(' ', startIndex + minChunkSize);
        if (spaceIndex === -1) {
          break;
        }
        segments.push(str.substring(startIndex, spaceIndex));
        startIndex = spaceIndex + 1;
      }
      if (startIndex < str.length) {
        segments.push(str.substring(startIndex));
      }
      return segments;
    },
  },
};

export default procurementChartMixin;
